import { handleMenuFloat } from './menu'
import { carregarUsuarios } from './usuario'

export function toggleShowDialog(idDialog) {
    return [
        changeShowDialog(idDialog),
        handleMenuFloat(null),
        carregarUsuarios([])
    ]
}

export function changeShowDialog(idDialog) {
    return {
        type: 'TOGGLE_SHOW_DIALOG',
        payload: idDialog
    }
}